import React from 'react'
import Radio from '@mui/material/Radio'
import FormControlLabel from '@mui/material/FormControlLabel'

interface IRadioForm {
  value: string
  label: string
}
/**
 * RadioForm Page
 *
 * @param __namedParameters IRadioForm
 * @returns JSX.Element
 * @category ReactComponents
 */
export const RadioForm: React.FC<IRadioForm> = ({ value = '', label = '' }) => {
  return (
    <FormControlLabel
      value={value}
      label={label}
      control={
        <Radio
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: 20,
            },
          }}
        />
      }
      sx={{ '& .MuiFormControlLabel-label': { fontSize: 16 } }}
    />
  )
}
